import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Is this a physical product?',
    a: 'No. This is a digital guide delivered instantly after purchase.'
  }, {
    q: 'How will I receive access?',
    a: "You'll receive immediate online access and download instructions."
  }, {
    q: 'How long is the guide?',
    a: 'The guide is designed to be practical and easy to follow.'
  }, {
    q: 'Is this medical advice?',
    a: 'No. This educational material is intended for informational purposes only and is not a substitute for professional dental advice.'
  }, {
    q: 'Is there a refund policy?',
    a: "Yes. Your purchase is protected by the vendor's satisfaction guarantee."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-25">
      <div className="max-w-3xl mx-auto px-6" data-id="element-26">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-slate-900 mb-12 text-center" data-id="element-27">
          Frequently Asked Questions
        </h2>

        <div className="space-y-3" data-id="element-28">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-slate-50 rounded-xl border border-slate-100 overflow-hidden" data-id="element-29">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-slate-100 transition-colors" aria-expanded={isOpen} data-id="element-30">
                  <span className="font-semibold text-slate-900 text-base pr-4" data-id="element-31">
                    {faq.q}
                  </span>
                  <span className="shrink-0 w-7 h-7 rounded-full bg-sky-500 text-white flex items-center justify-center" data-id="element-32">
                    {isOpen ? <MinusIcon size={16} data-id="element-33" /> : <PlusIcon size={16} data-id="element-34" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-35">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-36">
                      <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-37">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}